module.exports = __webpack_public_path__ + "img/img_xinshou_3.7aa42fb5.png";